import React from 'react';
import Icon from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { ReactComponent as QuickRepliesCross } from '../../../../assets/messageStatuses/closeCross.svg';
import s from './Header.module.scss';
const { Text } = Typography;
const Header = ({ onClose, channelSelect }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: s.titleWrapper },
        React.createElement("div", { className: s.title },
            React.createElement(Text, { className: s.titleText },
                React.createElement(Trans, { i18nKey: "quickReplies" }))),
        React.createElement("div", { className: s.rightGroup },
            channelSelect,
            React.createElement(Button, { type: "text", className: s.closeModal, icon: React.createElement(Icon, { component: QuickRepliesCross }), onClick: onClose, "aria-label": t('close'), title: t('close') }))));
};
export default Header;
